export default __webpack_public_path__ + "static/media/eq-logo-svg.d58cb743.svg";